// removed by extract-text-webpack-plugin
module.exports = {"exception":"antd-pro_-_-scaffold-src-components-Exception-exception","imgBlock":"antd-pro_-_-scaffold-src-components-Exception-imgBlock","imgEle":"antd-pro_-_-scaffold-src-components-Exception-imgEle","content":"antd-pro_-_-scaffold-src-components-Exception-content","desc":"antd-pro_-_-scaffold-src-components-Exception-desc","actions":"antd-pro_-_-scaffold-src-components-Exception-actions"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Exception/index.less
// module id = 432
// module chunks = 0 1